
import { FocusTrap } from 'focus-trap-vue';
import { disablePageScroll, enablePageScroll } from 'scroll-lock';
import { defineComponent } from 'vue';

export default defineComponent({
  components: { FocusTrap },
  props: {
    navData: { type: Object, required: true },
    pageUrlSegment: { type: String, required: true },
  },
  data() {
    return {
      isDesktop: window.innerWidth >= 768,
      menuOpen: false,
    };
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.isDesktop = window.innerWidth >= 768;
      if (this.isDesktop && this.menuOpen) {
        this.toggleMenu(false);
      }
    });
  },
  beforeUnmount() {
    this.onMenuClose();
  },
  methods: {
    /**
     * Toggle menu open state
     *
     * @param {boolean} state Force menu to a particular state
     */
    toggleMenu(state) {
      this.menuOpen = typeof state === 'boolean' ? state : !this.menuOpen;
      if (this.menuOpen) {
        this.onMenuOpen();
      } else {
        this.onMenuClose();
      }
    },

    /**
     * Listen for 'Escape' keypress to close menu
     *
     * @param {KeyboardEvent} ev
     */
    listenForEscape(ev) {
      if (['Esc', 'Escape'].includes(ev.key)) {
        this.toggleMenu(false);
      }
    },

    /**
     * Listen for a user clicking outside the menu while it's
     * open which will close the menu
     *
     * @param {MouseEvent} ev
     */
    listenForClickOut(ev) {
      if (ev.target === this.$refs.menuContainer) {
        this.toggleMenu(false);
      }
    },

    /**
     * When the menu opens, disable page scroll and capture focus
     */
    async onMenuOpen() {
      document.addEventListener('keydown', this.listenForEscape);
      document.addEventListener('click', this.listenForClickOut);
      disablePageScroll();
    },

    /**
     * When the menu closes, enable page scroll and release focus
     */
    onMenuClose() {
      document.removeEventListener('keydown', this.listenForEscape);
      document.removeEventListener('click', this.listenForClickOut);
      enablePageScroll();
    },
  },
});
